import Vue from 'vue';

export default {
  async getCallDurationData({ commit }) {
    return Vue.axios.get('/calls_duration')
      .then(({ data }) => {
        let newData = { // por si justo cambiaron al iniciar
          max_call_time: 0,
          show_alert: 60,
          text: '',
        };
        if (data && typeof data.body === 'object' && Object.keys(data.body).length > 0) {
          newData = data.body;
        }
        commit('SET_CALL_ALERT_CONFIGURATION', newData);
      })
      .catch(() => {
        console.error('No se pudo obtener datos de duracion de llamada');
      });
  },
  async initSound({ state, commit }, payload) {
    if (state.sound || (state.lastCallExceeded && state.lastCallExceeded === payload.callId)) return;
    try {
      let newSound = null;
      const context = new (window.AudioContext || window.webkitAudioContext)();
      const source = context.createBufferSource();
      const ruteMP3 = payload.soundURL;

      const response = await fetch(ruteMP3);
      const buffer = await response.arrayBuffer();
      const audioBuffer = await context.decodeAudioData(buffer);

      newSound = source;
      newSound.loop = true;
      newSound.buffer = audioBuffer;
      newSound.connect(context.destination);
      newSound.start();

      commit('SET_SOUND_ALERT', newSound);
      commit('SET_LAST_CALL_EXCEEDED', payload.callId);
    } catch (error) {
      console.error('Error to load MP3:', error);
    }
  },
  endSound({ state, commit }) {
    if (!state.sound) return;
    state.sound.stop();
    commit('SET_SOUND_ALERT', null);
  },
};



// WEBPACK FOOTER //
// ./src/store/call_time_and_alert/actions.js